import styled from '@emotion/styled';
import { Theme } from '@mui/material';

export const StyledWrapper = styled.div`
  box-sizing: border-box;
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 64px 32px 32px;

  * {
    -webkit-user-select: none; /* Safari */
    -ms-user-select: none; /* IE 10 and IE 11 */
    user-select: none; /* Standard syntax */
  }
`;

export const StyledLogo = styled.img`
  width: 218px;
  height: 70px;
  filter: blur(1px);
  opacity: 0.1;
  position: absolute;
  top: 10px;
  left: 50%;
  transform: translateX(-50%);
  padding: 10px 0 10px;
  user-drag: none;
`;

export const StyledContentWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 24px;
  width: 100%;
  text-align: center;
`;

export const StyledCloseButton = styled.button<{ theme?: Theme }>`
  padding: 0 24px;
  border: none;
  border-radius: 8px;
  min-width: 120px;
  height: 40px;
  background: ${({ theme }) => theme.palette.customSecondary.neutral[100]};
  cursor: pointer;
  transition:
    background 0.2s,
    color 0.2s;
  font-family: inherit;
  font-weight: 500;
  font-size: 14px;
  color: ${({ theme }) => theme.palette.customSecondary.primary.hover};

  :hover {
    background: ${({ theme }) => theme.palette.customSecondary.primary.subtleHover};
    color: ${({ theme }) => theme.palette.customSecondary.primary.active};
  }
`;
